import {gql} from "@irati/utils/gql"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const mutation = gql`
  mutation UpdateUserVerifiedPhoneNo($data: UpdateUserPhoneNoInput!) {
    updateUserPhoneNumber(data: $data)
  }
`

export const updateUserVerifiedPhoneNoKey = getQueryNames(mutation)[0]

export default mutation
